import React from "react";
import PropTypes from "prop-types";
import { NavTabs } from "../common/NavTabs";
import { Outlet } from "react-router-dom";
import styled from "@emotion/styled";

const Container = styled.div`
  margin: 20px;
`;

const Business = (props) => {
  return (
    <Container>
      <NavTabs />
      <Outlet />
    </Container>
  );
};

Business.propTypes = {};

export { Business };
